<template>
  <div class="h-full bg-white">
    <div
      role="img"
      :style="`background-image: url(${image.src})`"
      :alt="image.alt"
      class="h-44 bg-full"
    />
    <h1
      id="focus-target"
      class="flex-a h-12 px-3vw md:px-3 py-2 text-lg md:text-xl font-medium bg-highlight-1 leading-none focus-b"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="32" viewBox="0 0 26 32" v-bind:svg-inline="''" v-bind:class="'h-6 w-6 mr-2'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#fff" d="M4.384 22.054C2.149 19.786.769 16.671.769 13.234s1.38-6.553 3.617-8.822l-.001.002A12.185 12.185 0 0113.098.763h.034-.002.015a12.22 12.22 0 018.727 3.65l.001.001c2.235 2.268 3.615 5.383 3.615 8.82s-1.38 6.553-3.617 8.822l-8.706 8.854z"/><path fill="#464646" d="M13.128 1.588h.015c3.191 0 6.078 1.304 8.157 3.408l.001.001a11.575 11.575 0 013.382 8.192v.048-.002.03c0 3.202-1.292 6.103-3.383 8.209l.001-.001-8.136 8.266-8.21-8.276a11.575 11.575 0 01-3.382-8.192v-.048V13.195c0-3.202 1.292-6.103 3.383-8.209l-.001.001c2.081-2.1 4.966-3.4 8.155-3.4h.019-.001zm0-1.589h-.014a12.984 12.984 0 00-9.269 3.875l-.001.001C1.468 6.279.001 9.585.001 13.234s1.468 6.955 3.845 9.36l-.001-.001 9.322 9.406 9.248-9.396c2.376-2.404 3.843-5.71 3.843-9.359s-1.468-6.955-3.845-9.36l.001.001a12.976 12.976 0 00-9.275-3.886h-.011.001z"/><path fill="#464646" d="M22.746 11.742l-9.618 2.882-9.627-2.882 9.627-2.891z"/><path fill="#464646" d="M13.128 15.561L8.31 14.057v2.648c0 .99 2.152 1.792 4.818 1.792s4.818-.802 4.818-1.792v-2.648zM7.321 15.976a.956.956 0 11-1.911-.001.956.956 0 011.911.001z"/><path fill="#464646" d="M6.779 15.895h-.838l-.532 4.458h1.909zM6.834 15.372h-.946c0-1.198.126-2.441 1.63-3.35l.487.811c-1.081.666-1.171 1.504-1.171 2.54z"/></svg>
      {{ htmlDecode(category.heading) }}
    </h1>
    <nav aria-label="Subject" class="">
      <ol class="subject-list">
        <li
          v-for="subject in subjects.children"
          :key="subject.slug"
          class="subject-list__item"
        >
          <RouterLink
            :to="subject.slug"
            class="block px-3vw md:px-3 py-2 text-primary underline hover:bg-primary focus:bg-primary hover:text-white focus:text-white hover:font-bold focus:font-bold hover:no-underline focus:no-underline focus-b"
            v-html="subject.title"
          />
        </li>
      </ol>
    </nav>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Subjects',

  props: {
    category: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapState(['touch', 'mobile']),
    ...mapGetters(['subjects']),

    image() {
      if (this.subjects?.image) {
        return {
          src: this.subjects.image.sizes.medium,
          alt: this.subjects.image.alt
        }
      }
      return ''
    }
  }
}
</script>

<style>
@screen lg {
  .subject-list {
    columns: 2;
    column-gap: 0px;
  }

  .subject-list__item {
    break-inside: avoid;
  }
}
</style>
